module.exports = __webpack_public_path__ + "img/sm-pigs.6cef3be6.jpg";